import { defineStore } from 'pinia'


interface ICacheEntry {
  blob?: Blob
  objectUrl?: string
  size?: number
  createdAt: number
}

export const useFileCacheStore = defineStore('fileCache', {
  state: () => ({
    cache: {} as Record<string, ICacheEntry>
  }),
  actions: {
    key(fileType: string, fileId: string) {
      return `${fileType}:${fileId}`
    },
    set(fileType: string, fileId: string, blob: Blob) {
      const k = this.key(fileType, fileId)
      const prev = this.cache[k]
      if (prev?.objectUrl) URL.revokeObjectURL(prev.objectUrl)
      const objectUrl = URL.createObjectURL(blob)
      this.cache[k] = {
        blob,
        objectUrl,
        size: (blob as any).size ?? 0,
        createdAt: Date.now()
      }
    },
    getBlob(fileType: string, fileId: string): Blob | undefined {
      return this.cache[this.key(fileType, fileId)]?.blob
    },
    tryGetBlobByType(fileType: string): Blob | undefined {
      for (const k in this.cache) {
        if (k.startsWith(`${fileType}:`) || k.includes(fileType)) {
          return this.cache[k]?.blob
        }
      }
      return undefined
    },
    getObjectUrl(fileType: string, fileId: string): string | undefined {
      return this.cache[this.key(fileType, fileId)]?.objectUrl
    },
    has(fileType: string, fileId: string): boolean {
      return !!this.cache[this.key(fileType, fileId)]
    },
    delete(fileType: string, fileId: string): boolean {
      const k = this.key(fileType, fileId)
      const e = this.cache[k]
      if (!e) return false
      if (e.objectUrl) URL.revokeObjectURL(e.objectUrl)
      delete this.cache[k]
      return true
    },
    clear() {
      for (const k in this.cache) {
        const e = this.cache[k]
        if (e?.objectUrl) URL.revokeObjectURL(e.objectUrl)
      }
      this.cache = {}
    }
  }
})